module.exports = __webpack_public_path__ + "static/user.e6c3ad1c.svg";